import { memo } from 'react'
import { Link } from 'react-router-dom'
import { ArrowRight } from 'lucide-react'
import { APP_REGISTRY } from '@/apps/registry'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'

export const AppSelector = memo(function AppSelector() {
  return (
    <div className="bg-background min-h-screen">
      <div className="mx-auto max-w-5xl px-4 py-12 sm:px-6 lg:px-8">
        <header className="mb-10">
          <h1 className="text-3xl font-bold tracking-tight">Mockup apps</h1>
          <p className="text-muted-foreground mt-2 text-sm sm:text-base">
            Choose an app to open its fullscreen shell. Shared components and styles apply across
            all apps.
          </p>
        </header>

        <ul className="grid gap-4 sm:grid-cols-2">
          {APP_REGISTRY.map((app) => {
            const Icon = app.icon
            return (
              <li key={app.id}>
                <Link to={app.path} className="block h-full">
                  <Card className="hover:border-primary/40 h-full transition-colors hover:shadow-md">
                    <CardHeader>
                      <div className="flex items-start gap-3">
                        <div className="bg-primary/10 text-primary flex size-10 shrink-0 items-center justify-center rounded-lg">
                          <Icon className="size-5" />
                        </div>
                        <div className="min-w-0 flex-1">
                          <CardTitle className="text-lg">{app.name}</CardTitle>
                          <CardDescription className="mt-1">{app.description}</CardDescription>
                        </div>
                      </div>
                    </CardHeader>
                    <CardContent>
                      <span className="text-primary inline-flex items-center gap-1 text-sm font-medium">
                        Open app
                        <ArrowRight className="size-4" />
                      </span>
                    </CardContent>
                  </Card>
                </Link>
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  )
})
